import { useState } from "react";
import api, { apiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { ShieldCheck, Loader2 } from "lucide-react";

const when = (iso) => new Date(iso).toLocaleString([], { month: "short", day: "numeric", year: "numeric", hour: "numeric", minute: "2-digit" });

export const DncStatus = ({ l, testId }) => {
  const at = l.dnc_scrub_at || l.dnc_checked_at;
  if (!at) return <div className="text-xs text-slate-400" data-testid={testId}>DNC scrub: not run yet</div>;
  const listed = l.dnc_registry || l.dnc;
  const label = l.dnc_unverified ? "Couldn't verify" : listed ? "On DNC list" : "Not on DNC list";
  const tone = l.dnc_unverified ? "text-amber-700" : listed ? "text-red-700" : "text-emerald-700";
  return (
    <div className="text-xs text-slate-500" data-testid={testId}>
      DNC scrub {when(at)} · <span className={`font-semibold ${tone}`}>{label}</span>
    </div>
  );
};

export const DncScrubButton = ({ path, onDone, testId }) => {
  const [busy, setBusy] = useState(false);
  const go = async () => {
    setBusy(true);
    try {
      const { data } = await api.post(path);
      toast.success(`DNC scrub started for ${data.count} leads - results show on each lead in a minute or two`);
      if (onDone) setTimeout(onDone, 15000);
    } catch (e) { toast.error(apiError(e)); } finally { setBusy(false); }
  };
  return (
    <Button variant="outline" onClick={go} disabled={busy} data-testid={testId} title="Free - checks every lead with a phone against the National and state Do-Not-Call lists">
      {busy ? <Loader2 className="mr-2 h-4 w-4 animate-spin" /> : <ShieldCheck className="mr-2 h-4 w-4" />}DNC scrub
    </Button>
  );
};
